import React from 'react';

export const FontStylesDemo: React.FC<{}> = ({}) => {
    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <li style={{ color: 'grey' }}>Font Styles</li>
            <br />
            <h1>Header 1</h1>
            <h2>Header 2</h2>
            <h3>Header 3</h3>
            <h4>Header 4</h4>
            <h5>Header 5</h5>
            <h6>Header 6</h6>
            Body Text
            <br />
            <br />
            <span className='secondaryText'>Secondary Text</span>
            <br />
            <br />
            <span className='greenText'>Green Text</span>
            <br />
            <br />
        </div>
    );
};
